export enum RouteString {
  NOT_FOUND = 'not-found',
  ERROR = 'error',
  MAIN = 'main',
}

export enum LangRouteString {
  EN = 'en',
  UK = 'uk',
}
